import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { API_PATHS } from './api-paths';
export interface Pedido {
  id: number; codigoReferencia: string; asaasPaymentId?: string;
  compradorNome?: string; compradorEmail?: string; usuarioNome?: string;
  planoCodigo?: string; formaPagamento?: string; valorTotal?: number;
  statusPagamento?: string; criadoEm?: string;
}
@Injectable({providedIn:'root'})
export class PedidosService {
  private http=inject(HttpClient); private url=environment.apiUrl+API_PATHS.pedidos;
  listar(){return this.http.get<Pedido[]>(this.url);}
  cancelar(id:number){return this.http.post<{sucesso:boolean;mensagem:string}>(`${this.url}/${id}/cancelar`,{});}
}
